import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

export const Spinner = withStyles(props => ({
  circle: {
    stroke: '#ff9404',
  },
}))(CircularProgress);
